module.exports = "/_next/static/chunks/images/akira-38b6bd0e9b9c7d4cb89918e4f44a9c34.svg";